import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";
import DataTable from 'react-data-table-component';
import Popup from "react-popup";
import PronetTitulo from "./PronetTitulo"
import history from "../login/history";
import { formatoSeparadorMilesValue, splitImporte } from "../../generico/utils/FormatoInput";
import CabeceraWizard from "./CabeceraWizard"
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import MensajeUsuario from "../../generico/Login/MensajeLogin";
import { MENSAJE } from "../../generico/utils/Constantes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import resumenSocioService from "../../../services/resumenGeneral/resumenSocioService";
import { ModalPinTransaccional } from "../../generico/ModalPinTransaccional";

const COD_SERVICIO_SET = "55"; /// set
const COD_SERVICIO_TIGO = "474"; /// telepos


const AvisoSet = ({ codigo }) => {
  return (codigo === COD_SERVICIO_SET &&
    <div className="row invoice-info">
      <div className="col-12">
        <div className="row">
          <div className="col-md-12">
            <div
              className="callout callout-success"
              style={{
                border: "1px solid #006a2d",
                backgroundColor: "#ffffff00",
                boxShadow: "none",
              }}
            >
              <div className="row">
                <div className="col-md-12">
                  <i
                    className="fas fa-exclamation-circle card-fa-icono-info"
                    style={{ marginRight: 5, fontSize: 25 }}
                  />
                  <p style={{ fontSize: 20 }}>Importante!</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p class="mt-1 text-justify">{MENSAJE.TEXTO_SET}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default class PronetPaso4 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      codigo: props.codigo,
    };
  }

  componentDidMount() {

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  notifDoblePago = (props, state) =>

    Popup.register({
      title: "¡Atención!",
      content: "Ya se ha registrado un pago con el mismo número de boleta, por favor verifique los datos ingresados",
      buttons: {
        /*right: [
          {
            text: "Continuar Pagando",
            className: "success",
            action: function () {
              var codigo = props.codigo;
              var datos = state.datosPago; 
              var cuenta = props.nroCuenta; 
              var total = state.total; 
              var tipoTrx = props.tipoTrx;
              PagoServicioService.pagarPronet(codigo, datos, cuenta, total, tipoTrx)
                .then((response) => {
                  var ticket = "";
                  var data = JSON.stringify(response.data);
                  var jsonData = JSON.parse(data);
                  if (jsonData.codRetorno === '0') {
                    var camposRespuesta = jsonData.campo;
                    for (var i = 0; i < camposRespuesta.length; i++) {
                      if(camposRespuesta[i].name == "ticket")
                        ticket = camposRespuesta[i].value;              
                    }
                    props.respuestaPaso4(JSON.parse(JSON.stringify(ticket)), jsonData.codTrxRecaudadora);
                    state.ticket = ticket;
                    props.nextStep();
                  }
                  else {
                    if(jsonData.codRetorno === '100005'){ //// pago duplicado SET
                      Popup.create({
                        title: 'Info',
                        content: jsonData.desRetorno,
                        buttons: {
                          right: [
                            {
                              text: "Aceptar",
                              className: "success",
                              action: function () {
                                Popup.close();
                              },
                            },
                          ]
                        }
                      }, true);
                    }else{
                      Popup.create({
                        title: 'Info',
                        content: "Los pagos de SET son a confirmar. Verifique en el transcurso de 10 minutos en reimpresión de tickets si se encuentra aprobado su pago. Cualquier rechazo o inconveniente será contactado por funcionarios de la CU.",
                        buttons: {
                          right: [
                            {
                              text: "Aceptar",
                              className: "success",
                              action: function () {
                                Popup.close();
                              },
                            },
                          ]
                        }
                      }, true);
                    }
                    
                    return;
                  }
                })
                .catch(function (error) {
                  console.log(error)
                  Popup.create({
                    title: 'Atención',
                    content: "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
                    buttons: {
                      right: [
                        {
                          text: "Aceptar",
                          className: "success",
                          action: function () {
                            Popup.close();
                          },
                        },
                      ]
                       
                    }
                  }, true);
                });
                Popup.close();
            },
          },
        ],*/
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              //history.push('/PagoServicio');
              history.push(ConfigService.getPathByName("pagoServicio")?.url);
              window.location.reload();
            },
          },
        ],
      },

    });

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }


  getDatos() {

    var respuesta = [];
    var valorPago = [];
    var montoTotal = "";
    var montoFinal = "";
    var cliente = 0;
    var codigoSet = false;
    var jsonData = JSON.parse(JSON.stringify(this.props.paso3));
    //seteamos los valores de la cabecera
    if (this.props.datosCliente === null) {
      cliente = 1;
    }
    if (this.props.datosCliente === undefined) {
      cliente = 1;
    }
    if (cliente === 0) {
      for (let index = 0; index < this.props.datosCliente.length; index++) {
        respuesta.push({
          concepto: this.props.datosCliente[index].label,
          valor: this.props.datosCliente[index].value
        });

        valorPago.push({
          name: this.props.datosCliente[index].name,
          value: this.props.datosCliente[index].value
        });

      }
    }
    for (var i = 0; i < jsonData.length; i++) {
      var datos = JSON.parse(JSON.stringify(jsonData[i]));
      var montoActual = datos.valor

      if (datos.format === "MONEY") {
        var montoActual = formatoSeparadorMilesValue(datos.valor)
      }
      respuesta.push({
        concepto:
          datos.label,
        valor: montoActual
      })
      if (datos.format === "MONEY") {
        montoTotal = splitImporte(datos.valor);
        valorPago.push({
          name:
            datos.name,
          value: montoTotal
        })
        if (datos.debitable === "true") {
          montoFinal = splitImporte(datos.valor);
        }
      }


      else {
        if (datos.type === "OPTION") {
          valorPago.push({
            name:
              datos.concepto,
            value: datos.options[0].option[0].value
          })

        } else {
          valorPago.push({
            name:
              datos.concepto,
            value: datos.valor
          })

        }
      }
      if (datos.codServicio === "55") {
        codigoSet = true;
      }
    }
    this.setState({ datos: respuesta, datosPago: valorPago, total: montoFinal, codigoSet: codigoSet });
  }

  reemplazarPunto = (valor) => {

    var resultado = valor.replace(".", "");
    var original = resultado;
    var reemplazo = true;
    while (reemplazo) {
      resultado = resultado.replace(".", "");
      if (resultado === original)
        reemplazo = false
      else
        original = resultado

    }
    return resultado;
  };
  reemplazarBarra = (valor) => {
    var resultado = valor.replace("/", "");
    var original = resultado;

    var reemplazo = true;
    while (reemplazo) {
      resultado = resultado.replace("/", "");
      if (resultado == original)
        reemplazo = false
      else
        original = resultado

    }
    var fecha = original.substring(0, original.length - 4)
    fecha = fecha + original.substring(original.length - 2, original.length) + "000000"

    return fecha;
  };


  pagar = (e) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    //// control de pago duplicado
    this.esPagoDuplicado();

  }

  esPagoDuplicado() {

    switch (this.props.codigo) {
      case COD_SERVICIO_SET:

        var nroBoleta = JSON.parse(JSON.stringify(this.state.datosPago[0])).value;
        var codigo = this.props.codigo
        var nroCuenta = this.props.nroCuenta
        var monto = this.state.total
        trackPromise(
          PagoServicioService.consultarPagoDuplicado(codigo, nroCuenta, monto, nroBoleta)
            .then((response) => {
              this.btn.removeAttribute("disabled");
              var data = JSON.stringify(response.data);
              var jsonData = JSON.parse(data);
              console.log(jsonData);
              if (jsonData.codRetorno === '0') {
                if (jsonData.duplicado === "DUPLICADO_SI") {
                  Popup.queue(this.notifDoblePago(this.props, this.state));
                } else {
                  this.procesarPago();
                }
              }
              else {
                this.btn.removeAttribute("disabled");
                const resMessage = jsonData.desRetorno;
                this.setState({
                  loading: false,
                  message: resMessage
                });
              }
            })
            .catch(function (error) {
              console.log(error)
              var msg = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";
              Popup.queue(this.notifiPopup("Info", msg));
              return
            }));

        break;
      default:
        this.procesarPago();
        break;
    }

  }

  async procesarPago() {
    var ticket = "";
    trackPromise(
      PagoServicioService.pagarPronet(this.props.codigo, this.state.datosPago, this.props.nroCuenta, this.state.total, this.props.tipoTrx)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codRetorno === '0') {
            this.mostrarMensajePorServicio(jsonData.codServicio, jsonData.codRetorno);
            var camposRespuesta = jsonData.campo;
            for (var i = 0; i < camposRespuesta.length; i++) {
              if (camposRespuesta[i].name == "ticket")
                ticket = camposRespuesta[i].value;
            }
            this.props.respuestaPaso4(JSON.parse(JSON.stringify(ticket)), jsonData.codTrxRecaudadora);
            this.setState({ ticket: ticket });

            this.step5.click();
          }
          else {
            //// Habilita boton
            this.btn.removeAttribute("disabled");
            switch (this.props.codigo) {
              case COD_SERVICIO_SET:
                if (jsonData.codRetorno === '100005') { //// pago duplicado SET
                  Popup.queue(this.notifiPopup("Info", jsonData.desRetorno));
                } else {
                  this.mostrarMensajePorServicio(this.props.codigo, jsonData.codRetorno);
                }
                break;
              default:
                this.mostrarMensajePorServicio(jsonData.codServicio, jsonData.codRetorno, jsonData.desRetorno);
                break;
            }

            return;
          }
        },
          error => {
            //// Habilita boton
            this.btn.removeAttribute("disabled");
            switch (this.props.codigo) {
              case COD_SERVICIO_SET:
                this.mostrarMensajePorServicio(this.props.codigo, '99');
                break;
              default:
                var msg = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";
                Popup.queue(this.notifiPopup("Info", msg));
                break;
            }
          }
        ));
  }



  volver = (e) => {
    this.setState({ datos: undefined });
    this.props.goToStep(3);
    // this.atras.click();
  }

  volverPagoServicio = (e) => {
    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicio")?.url);
    window.location.reload();
  }


  /**
   * @author m_bareiro
   * Muestra mensaje personalizado dependiendo del servicio o metodo de pago
   * @param codServicio
   */
  mostrarMensajePorServicio(codServicio, codRetorno, mensajeServidor = '') {

    //// SET
    if (codServicio === COD_SERVICIO_SET && codRetorno !== '0') {
      var msg = "Los pagos de SET son a confirmar. Verifique en el transcurso de 10 minutos en reimpresión de tickets si se encuentra aprobado su pago. Cualquier rechazo o inconveniente será contactado por funcionarios de la CU.";
      Popup.queue(this.notifiPopup("Info", msg));
      return
    }
    //// TIGO
    if (codServicio === COD_SERVICIO_TIGO && codRetorno == '0') {
      var msg = "Pago por telepos tiene un tiempo de procesamiento de 24 a 48 hs. Para realizar pagos online de tigo, el cliente puede utilizar la opción Telefonia/Soluciones desde Cu24hs"
      Popup.queue(this.notifiPopup("Info", msg));
      return
    }
    //// mensaje para pago de codigo de barra
    if (this.props.esCodigoBarra === "OK" && codRetorno == '0') {
      var msg = "Pago por código de barras tiene un tiempo de procesamiento de 24 a 48 hs.";
      Popup.queue(this.notifiPopup("Info", msg));
      return
    }
    //// cualquier otro servicio
    if (mensajeServidor !== '') {
      Popup.queue(this.notifiPopup("Info", mensajeServidor));
      return
    }

  }

  render() {
    if (this.props.currentStep !== 5) { // Prop: The current step
      return null
    }

    if (this.props.currentStep === 5 && this.state.datos === undefined) {
      this.getDatos()
    }

    return (
        <div>
          {/******************* CABECERA WIZARD ***********************/}
          <div className="row">
            <CabeceraWizard
              nombre={this.props.nombre}
              tittle1="disabled"
              tittle2="disabled"
              tittle3="disabled"
              tittle4="disabled"
              tittle5="current"
              tittle6="disabled"
            />
          </div>

          <PronetTitulo img={this.props.img} empresa={this.props.empresa} />
          <hr />

          {/******************* LOGICA PASOS ***********************/}
          <div className="row justify-content-md-center">
            <div className="col-md-8">
              <div className="form-group">
                <label className="input-label">
                  Cuenta Origen (a debitar):
                </label>
                <br />
                <label className="input-label-bold">{this.props.cuenta}</label><br />

              </div>
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-md-10 table-responsive">
              <div className="invoice p-3 mb-3">
                <div className="row">
                  <div className="col-12">
                    <h5>
                      Datos del Pago
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <DataTable
                    noHeader={true}
                    columns={this.getColumn()}
                    data={this.state.datos}
                    dense={true}
                    noDataComponent="No se tiene datos que mostrar"
                    responsive={true}
                    noTableHead={true} />
                </div>
              </div>
              <AvisoSet codigo={this.props.codigo} />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4 btn-consulta">
              <button className="btn btn-cu-secundary" onClick={this.volverPagoServicio}><FontAwesomeIcon icon={faMoneyCheckDollar} /> Pagar Otro Servicio</button>
            </div>
            <div className="col-md-4 btn-consulta">
              <button className="btn btn-cu-quintary" onClick={this.volver} ><FontAwesomeIcon icon={faArrowLeft} /> Volver</button>
            </div>
            <div className="col-md-4">
              <button
                data-toggle="modal"
                data-target="#modal-pin-pago-servicio"
                className="btn btn-cu-primary"
                ref={btn => { this.btn = btn; }}>Confirmar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <ModalPinTransaccional id="modal-pin-pago-servicio" onSuccess={this.pagar} />
            </div>
            <button
              hidden
              ref={(a) => (this.step5 = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
            <button
              hidden
              ref={(a) => (this.atras = a)}
              className="btn btn-cu-primary"
              onClick={this.props.previousStep}
            ></button>
          </div>
        </div>
    );
  }
}